import { ArticleHeading4 } from '@cian/ui-kit';
import * as React from 'react';
import { ReturnToRegularAdButton } from '../buttons/ReturnToRegularAdButton/ReturnToRegularAdButton';
import styles from './ReturnToRegularAdBlock.css';
import { IReturnToRegularAdBlockProps } from './types';

export const ReturnToRegularAdBlock: React.FC<IReturnToRegularAdBlockProps> = props => {
  const { onReset } = props;

  return (
    <div className={styles['container']}>
      <ArticleHeading4 color="gray60_100">Мультиобъявление</ArticleHeading4>
      <div className={styles['button-container']}>
        <ReturnToRegularAdButton onClick={onReset} />
      </div>
    </div>
  );
};
